"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useDynamicValues_1 = require("./useDynamicValues");
exports.useDynamicString = function (name, context) {
    var interpreter = useDynamicValues_1.useDynamicValues();
    return interpreter.getString(name, context);
};
exports.useDynamicBoolean = function (name, context) {
    var interpreter = useDynamicValues_1.useDynamicValues();
    return interpreter.getBoolean(name, context);
};
exports.useDynamicFloat = function (name, context) {
    var interpreter = useDynamicValues_1.useDynamicValues();
    return interpreter.getFloat(name, context);
};
exports.useDynamicInt = function (name, context) {
    var interpreter = useDynamicValues_1.useDynamicValues();
    return interpreter.getInt(name, context);
};
exports.useDynamicJson = function (name, context) {
    var interpreter = useDynamicValues_1.useDynamicValues();
    return interpreter.getJson(name, context);
};
